import { Clock3, LogOut } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/contexts/AuthContext";

export default function PendingAccess() {
  const { user, logout } = useAuth();
  return (
    <main className="min-h-screen bg-[#F2F6F6] flex items-center justify-center p-5" data-testid="pending-access-screen">
      <section className="w-full max-w-md border border-slate-200 bg-white p-7 text-center">
        <div className="mx-auto h-11 w-11 flex items-center justify-center bg-[#E7F5F5] text-[#0A838A]"><Clock3 size={22} /></div>
        <p className="mt-5 text-[11px] font-bold uppercase tracking-wide text-[#0A838A]">Access management</p>
        <h1 className="mt-1 text-xl font-heading font-bold text-slate-900">Your access is pending</h1>
        <p className="mt-3 text-sm leading-relaxed text-slate-600">{user?.email} has signed in successfully. An administrator must grant page access before you can continue.</p>
        <Button onClick={logout} data-testid="pending-access-sign-out-button" variant="outline" className="mt-6 font-bold"><LogOut size={14} /> Sign out</Button>
      </section>
    </main>
  );
}